import { useMutation, useQueryClient } from '@tanstack/react-query';
import { queryKeys } from '../../../config/queryClient';
import { createTasks, updateTaskDetails, deleteTask } from 'services/CaseServices';

export const useCreateTaskMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ data, is_lead = false }) => {
      const response = await createTasks(data, is_lead);
      return response.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: queryKeys.tasks.all });
    },
  });
};

export const useUpdateFullTaskMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ taskId, data, isReminderUpdated = false, is_lead = false }) => {
      const response = await updateTaskDetails(taskId, null, data, isReminderUpdated, is_lead);
      return response.data;
    },
    onSuccess: () => {
      // Invalidate all task queries to refetch
      queryClient.invalidateQueries({ queryKey: queryKeys.tasks.all });
    },
  });
};

export const useDeleteTaskMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ taskId, caseId, pk, is_lead = false }) => {
      const response = await deleteTask(caseId, taskId, pk, is_lead);
      return response.data;
    },
    onSuccess: () => {
      // Invalidate all task queries to refetch
      queryClient.invalidateQueries({ queryKey: queryKeys.tasks.all });
    },
  });
};
